import type { JourneePreparee, PossibleDuJour } from '../../partage/api/types';
import type { Choix } from './journeeEnCours';

/**
 * Changer sa journée sans perdre ce qui est déjà fait (ticket 04 du chantier telephone). Sans
 * rendu.
 *
 * Une tâche cochée n'est plus « possible » (le serveur ne la propose plus), mais elle reste dans
 * la journée : à sa place, faite, et elle compte dans le temps utilisé. Dans « Préparer ma
 * journée » (chantier `revue-design`, ticket 06), elle ne se remplace ni ne se retire.
 */

/** Les tâches déjà faites d'une journée préparée. */
export function faitesDeLaJournee(journee: { taches: readonly Pick<JourneePreparee['taches'][number], 'bulleId' | 'etat'>[] } | null | undefined): Set<string> {
  return new Set((journee?.taches ?? []).filter((t) => t.etat === 'fait').map((t) => t.bulleId));
}

/**
 * Les choix qui restent quand la liste des possibles change (une journée d'aujourd'hui rouverte,
 * un autre « où ») : ce qui est encore possible, et ce qui est déjà fait. Le reste (bloqué, hors
 * de ce « où ») part. L'ordre ne change pas.
 */
export function choixGardes(choisis: readonly string[], possibles: readonly string[], faites: ReadonlySet<string>): string[] {
  const ici = new Set(possibles);
  return choisis.filter((id) => ici.has(id) || faites.has(id));
}

/**
 * La même règle sur les choix d'une journée qu'on compose : ce qui est encore possible et ce qui
 * est fait restent, avec leurs heures fixées, dans l'ordre (chantier `nettoyage-journee`, ticket 02).
 */
export function garderLesPossibles(choix: readonly Choix[], possibles: readonly Pick<PossibleDuJour, 'id'>[], faites: ReadonlySet<string>): Choix[] {
  const gardes = new Set(choixGardes(choix.map((c) => c.id), possibles.map((p) => p.id), faites));
  return choix.filter((c) => gardes.has(c.id));
}
